import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

const services = [
  {
    id: 'vaciado-pisos',
    icon: 'ri-home-4-line',
    title: 'Vaciado de pisos y casas',
    description: 'Servicio completo de vaciado de viviendas en Vic y comarca de Osona. Nos encargamos de retirar todos los muebles, enseres, electrodomésticos y objetos personales de forma rápida y eficiente.',
    details: [
      'Vaciado completo de pisos, casas y áticos',
      'Retirada de muebles y enseres',
      'Desmontaje de mobiliario si es necesario',
      'Limpieza final del espacio',
      'Gestión legal de todos los residuos',
      'Servicio en Centre Històric, El Remei, Horta Vermella, Estadi y toda Vic',
    ],
    benefits: 'Ideal para herencias, mudanzas, pisos en venta o alquiler. Dejamos el espacio completamente vacío y limpio, listo para su nuevo uso.',
    image: 'https://public.readdy.ai/ai/img_res/f9279551b18a8db4ecabdbd9896f00e4.jpg',
  },
  {
    id: 'vaciado-locales',
    icon: 'ri-store-2-line',
    title: 'Vaciado de locales comerciales',
    description: 'Vaciado integral de locales comerciales, oficinas, naves industriales y trasteros en Vic, Manlleu, Torelló y toda la comarca. Servicio profesional adaptado a las necesidades de tu negocio.',
    details: [
      'Vaciado de locales comerciales y oficinas',
      'Retirada de mobiliario de oficina',
      'Desmontaje de estanterías y expositores',
      'Retirada de maquinaria ligera',
      'Limpieza profunda del local',
      'Coordinación de horarios según tus necesidades',
    ],
    benefits: 'Perfecto para cierres de negocio, traspasos, reformas o cambios de actividad. Trabajamos fuera del horario comercial si lo necesitas.',
    image: 'https://readdy.ai/api/search-image?query=empty%20commercial%20space%20after%20clearance%20clean%20white%20walls%20bright%20lighting%20professional%20cleared%20retail%20space%20modern%20minimalist&width=800&height=600&seq=servicio-vaciado-locales&orientation=landscape',
  },
  {
    id: 'retirada-muebles',
    icon: 'ri-truck-line',
    title: 'Retirada de muebles y electrodomésticos',
    description: 'Servicio profesional de retirada de muebles y electrodomésticos en Vic y Osona. Importante: servicio mínimo una furgoneta llena. No recogemos muebles sueltos individuales como una sola mesa, una butaca o una silla.',
    details: [
      'Retirada de muebles voluminosos',
      'Transporte de electrodomésticos',
      'Desmontaje si es necesario',
      'Carga y transporte incluidos',
      'Gestión de residuos en puntos autorizados',
      'Servicio mínimo: una furgoneta llena',
    ],
    benefits: 'Solución práctica para renovar tu hogar o negocio. Nos encargamos de todo el proceso de principio a fin.',
    image: 'https://readdy.ai/api/search-image?query=professional%20movers%20loading%20furniture%20into%20truck%20organized%20efficient%20service%20clean%20modern%20van%20workers%20in%20uniform&width=800&height=600&seq=servicio-retirada-muebles&orientation=landscape',
  },
  {
    id: 'diogenes',
    icon: 'ri-heart-pulse-line',
    title: 'Limpieza por síndrome de Diógenes',
    description: 'Servicio especializado y discreto para casos de síndrome de Diógenes en Vic y comarca. Nuestro equipo está formado específicamente para tratar estas situaciones delicadas con el máximo respeto y profesionalidad.',
    details: [
      'Equipo especializado en síndrome de Diógenes',
      'Máxima discreción y confidencialidad',
      'Trato respetuoso y empático',
      'Limpieza profunda y desinfección',
      'Gestión de objetos personales con sensibilidad',
      'Coordinación con familiares y servicios sociales',
    ],
    benefits: 'Entendemos la complejidad de estas situaciones. Trabajamos con sensibilidad, respeto y total confidencialidad para recuperar el espacio de forma digna.',
    image: 'https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20protective%20equipment%20working%20carefully%20organized%20systematic%20approach%20clean%20bright%20workspace%20respectful%20service&width=800&height=600&seq=servicio-diogenes&orientation=landscape',
  },
  {
    id: 'limpieza-extrema',
    icon: 'ri-sparkling-2-line',
    title: 'Limpieza de suciedad extrema',
    description: 'Limpieza profunda y desinfección en casos de suciedad extrema en Vic, Manlleu, Torelló y toda Osona. Utilizamos productos profesionales y técnicas especializadas para garantizar resultados óptimos.',
    details: [
      'Limpieza profunda de espacios muy sucios',
      'Desinfección completa con productos profesionales',
      'Eliminación de malos olores',
      'Tratamiento de manchas difíciles',
      'Limpieza de paredes, suelos y techos',
      'Equipamiento de protección profesional',
    ],
    benefits: 'Recuperamos espacios en condiciones extremas dejándolos completamente limpios, desinfectados y habitables. Garantizamos resultados óptimos.',
    image: 'https://readdy.ai/api/search-image?query=clean%20sanitized%20room%20after%20extreme%20cleaning%20white%20walls%20shiny%20floor%20fresh%20bright%20space%20professional%20results&width=800&height=600&seq=servicio-limpieza-extrema-nueva&orientation=landscape',
  },
  {
    id: 'pintura-reparaciones',
    icon: 'ri-paint-brush-line',
    title: 'Pintura final y pequeñas reparaciones',
    description: 'Servicio complementario de pintura y pequeñas reparaciones para dejar tu piso o local completamente listo en Vic y comarca. Acabados profesionales y atención al detalle.',
    details: [
      'Pintura de paredes y techos',
      'Reparación de pequeños desperfectos',
      'Arreglo de agujeros y grietas',
      'Lijado y preparación de superficies',
      'Acabados profesionales',
      'Limpieza final incluida',
    ],
    benefits: 'Complementa el vaciado con pintura y reparaciones para entregar el espacio en perfectas condiciones, listo para vender, alquilar o habitar.',
    image: 'https://readdy.ai/api/search-image?query=professional%20painter%20working%20on%20white%20walls%20clean%20bright%20room%20modern%20interior%20painting%20service%20quality%20finish&width=800&height=600&seq=servicio-pintura&orientation=landscape',
  },
];

export default function ServiciosPage() {
  useEffect(() => {
    document.title = 'Servicios de Vaciado de Pisos y Locales en Vic | JUSTCLEAN VIC';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Servicios profesionales de vaciado de pisos, locales, limpieza Diógenes y retirada de muebles en Vic y Osona. Presupuesto sin compromiso ☎️ 602 36 59 96'
      );
    }

    // Add ItemList Schema for services
    const servicesScript = document.createElement('script');
    servicesScript.type = 'application/ld+json';
    servicesScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Servicios de JUSTCLEAN VIC',
      description: 'Lista completa de servicios de vaciado y limpieza en Vic',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/servicios`,
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'Service',
            name: 'Vaciado de Pisos y Casas',
            description: 'Servicio completo de vaciado de viviendas en Vic y comarca',
            provider: {
              '@type': 'LocalBusiness',
              name: 'JUSTCLEAN VIC',
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'Service',
            name: 'Vaciado de Locales Comerciales',
            description: 'Vaciado profesional de locales comerciales y oficinas',
            provider: {
              '@type': 'LocalBusiness',
              name: 'JUSTCLEAN VIC',
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'Service',
            name: 'Limpieza Síndrome de Diógenes',
            description: 'Servicio especializado y discreto para casos de síndrome de Diógenes',
            provider: {
              '@type': 'LocalBusiness',
              name: 'JUSTCLEAN VIC',
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'Service',
            name: 'Retirada de Muebles y Electrodomésticos',
            description: 'Recogida y gestión responsable de muebles y electrodomésticos',
            provider: {
              '@type': 'LocalBusiness',
              name: 'JUSTCLEAN VIC',
            },
          },
        },
      ],
    });
    document.head.appendChild(servicesScript);

    return () => {
      document.head.removeChild(servicesScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-primary to-red-700 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6">
              Nuestros servicios en Vic y Osona
            </h1>
            <p className="text-lg max-w-3xl mx-auto opacity-95 leading-relaxed">
              Ofrecemos soluciones completas de <strong>vaciado de pisos y locales</strong>, <strong>limpieza por síndrome de Diógenes</strong>, <strong>retirada de muebles y electrodomésticos</strong> y <strong>limpieza de suciedad extrema</strong> en Vic, Manlleu, Torelló, Taradell, Tona y toda la comarca de Osona. Servicio profesional, discreto y urgente disponible 24 horas. <Link to="/empresa" className="underline hover:text-secondary font-semibold">Conoce nuestra empresa</Link> y nuestros más de 10 años de experiencia.
            </p>
          </div>
        </section>

        {/* Servicios Detallados */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-20" data-product-shop>
              {services.map((service, index) => (
                <div
                  key={service.id}
                  id={service.id}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                  }`}
                >
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                    <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                      <i className={`${service.icon} text-3xl text-primary`}></i>
                    </div>
                    <h2 className="text-3xl font-bold text-dark mb-4">{service.title}</h2>
                    <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                      {service.description}
                    </p>
                    <div className="mb-6">
                      <h3 className="text-lg font-bold text-dark mb-3">¿Qué incluye?</h3>
                      <ul className="space-y-2">
                        {service.details.map((detail, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                              <i className="ri-check-line text-primary text-lg"></i>
                            </div>
                            <span className="text-sm text-gray-700">{detail}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="bg-secondary/10 rounded-lg p-4 mb-6">
                      <p className="text-sm text-gray-700 leading-relaxed">
                        <strong className="text-dark">Casos típicos:</strong> {service.benefits}
                      </p>
                    </div>
                    <Link
                      to="/contacto"
                      className="inline-block bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm"
                    >
                      Solicitar presupuesto
                    </Link>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-auto rounded-lg shadow-xl object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Zonas de Servicio */}
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-dark mb-4">
                Trabajamos en toda la comarca de Osona
              </h2>
              <p className="text-base text-gray-600 max-w-3xl mx-auto">
                Ofrecemos todos nuestros servicios en Vic (Centre Històric, El Remei, Horta Vermella, Estadi, Vic Sud, Serra-de-senferm, Caputxins) y localidades cercanas como Manlleu, Torelló, Taradell, Tona, Gurb, Calldetenes, Roda de Ter y Folgueroles. <Link to="/faq" className="text-primary hover:text-red-700 font-semibold">Consulta nuestras preguntas frecuentes</Link> para más información sobre zonas de servicio.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">Servicio urgente 24h</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Disponibilidad inmediata para emergencias. Te atendemos cualquier día de la semana.
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-file-list-3-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">Presupuesto sin compromiso</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Valoración gratuita y presupuesto detallado sin ningún tipo de compromiso. <Link to="/contacto" className="text-primary hover:text-red-700 font-semibold">Solicítalo ahora</Link>.
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">Servicio discreto</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Máxima confidencialidad en todos nuestros trabajos, especialmente en casos delicados. <Link to="/empresa" className="text-primary hover:text-red-700 font-semibold">Conoce nuestros valores</Link>.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-dark mb-6">
              ¿Necesitas alguno de nuestros servicios?
            </h2>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              <Link to="/contacto" className="text-primary hover:text-red-700 font-semibold">Contacta con nosotros</Link> ahora y obtén un presupuesto personalizado sin compromiso. Atendemos en Vic, Manlleu, Torelló y toda la comarca de Osona. Si tienes dudas, revisa nuestras <Link to="/faq" className="text-primary hover:text-red-700 font-semibold">preguntas frecuentes</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+34602365996"
                className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm inline-flex items-center justify-center"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar: 602 36 59 96
              </a>
              <a
                href="https://wa.me/34602365996"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm inline-flex items-center justify-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
      <CookieBanner />
    </div>
  );
}
